import { Alert, AlertIcon, Button, HStack, Text, VStack } from '@chakra-ui/react'

interface IReviewBannerProps {
  changeCount: number
  onViewSummary: () => void
  onMarkAsReviewed: () => void
  isAllReviewed: boolean
  markActionLabel?: string
}

const ReviewBanner = ({
  changeCount,
  onViewSummary,
  onMarkAsReviewed,
  isAllReviewed,
  markActionLabel = 'Mark as reviewed'
}: IReviewBannerProps) => {
  return (
    <Alert status="error" backgroundColor="red.500" borderRadius="md">
      <AlertIcon color="white" />
      <VStack align="start" flex="1" spacing={0}>
        <Text fontSize="sm" color="white" fontWeight={500} mb={0}>
          {changeCount} changes made to this process. Please review and acknowledge the updates
        </Text>
      </VStack>
      <HStack spacing={2} ml={4}>
        <Button
          size="sm"
          variant="outline"
          color="white"
          fontWeight={500}
          onClick={onViewSummary}
          backgroundColor="red.500"
          border="none"
          _hover={{ backgroundColor: 'red.500' }}
        >
          View summary
        </Button>
        <Button
          size="sm"
          color="white"
          fontWeight={500}
          onClick={onMarkAsReviewed}
          _hover={{ backgroundColor: 'rgba(255, 255, 255, 0.36)', opacity: 0.9 }}
          border="none"
          backgroundColor="rgba(255, 255, 255, 0.36)"
        >
          {markActionLabel}
        </Button>
      </HStack>
    </Alert>
  )
}

export default ReviewBanner

